<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useMemberService } from "@/stores/memberFunction/memberService";

import search_btn from "@image/memberFunction/08/search_btn.png";
import 會員選擇無 from "@image/memberFunction/common/會員選擇無.png";
import 會員選擇 from "@image/memberFunction/common/會員選擇.png";
import 頁面跳轉 from "@image/memberFunction/common/頁面跳轉.png";
import no_file from "@image/memberFunction/文字框/no_file.png";
import cs_add_bg from "@image/memberFunction/04/cs_add_bg.png";
import line_icon from "@image/memberFunction/04/line_icon.png";

const { t } = useI18n();

const memberService = useMemberService();
function ToLineLink() {
  memberService.getWebTalkLineService();
}

</script>
<template>
  <div class="px-[1em] md:px-[5dvh]">
    <div class="flex flex-col items-center p-[50px] gap-[30px]">
      <p v-html="t('MemberFunction.Deposit.SmallAmountPageContext')" />
      <div class="relative flex justify-around items-center mb-5">
        <button class="flex justify-center items-center btn-y-border gap-[15px] w-[240px] h-[72px]" @click="ToLineLink">
          <img class="w-[35px]" v-img-src="line_icon" alt="" />
          <div class="text-[16px] text-secondary">
            {{ $t("Context.Service.LineService") }}
          </div>
        </button>
      </div>
    </div>
  </div>
</template>
